import React, { useEffect, useState } from "react";
import { Box, Flex, Menu, MenuButton, MenuList, Tag, Text, useColorModeValue} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import RecordTable from "./RecordTable/RecordTable";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import {  paymentRecordColumns } from "./RecordTable/ColumnData";
import { fetchAsyncSearchPaymentRecords } from "redux/invoicePaymentRecordSlice";
import { pmtNumberFormate } from "jsFunctions/helperFunctions";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import InvoicePaymentRecordModel from "components/models/invoicePaymentRecordModel";
import ExportDataModel from "components/exportData/ExportDataModel";
import { CiExport } from "react-icons/ci";
import { FaEllipsisV } from "react-icons/fa";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";

const InvoicePaymentRecords = () => {
  const [paymentRecordData, setPaymentRecordData] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [openPaymentInfoModel, setOpenPaymentInfoModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const currUser = useSelector((state) => state.auth.currUser);
  const [role,setRole] = useState('')  

  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  let menuBg = useColorModeValue("white", "navy.800");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  useEffect(()=>{
    if(currUser && currUser?.auth){
      const auth = currUser?.auth;
      const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === 'Invoice Tds');
      if(roleObj){
        setRole(roleObj?.access)
      }
    }
  },[currUser])

  const paymentRecords = useSelector((state) => state.paymentRecords);
  const dispatch = useDispatch();
 
  useEffect(() => {
    setLoading(true); 
    dispatch(fetchAsyncSearchPaymentRecords({}))
      .then(() => {
        setLoading(false); 
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false); 
      });
  }, []);

  useEffect(() => {
    if (paymentRecords?.recordsData && paymentRecords?.recordsData.length > 0) {
      const tableData = paymentRecords?.recordsData.map((record, index) => {
        const payMod = allPaymentMode.find(opt=> opt.id === record?.mod);

        return {
          _id:record._id,
          no: index + 1,
          inNo: (
            <span 
              style={{ cursor: "pointer",color:'blue'}}
            >
              {record.inId ? InvoiceNumberFormate(record?.inId?.inNo) : "-"}
            </span>
          ),
          client: <span>{record?.cId?.clName || "-"}</span> ,
          paymentMode: <Tag bg="green" color="white">{payMod?.value || "-"}</Tag> ,
          paymentId: (
            <span 
              style={{ cursor: "pointer",color:'blue'}}
            >
              {record.pyNo ? pmtNumberFormate(record?.pyNo) : "-"}
            </span>
          ),
          sortBaseAmt:record?.amt || 0,
          amount:(
            <span className="green f-600">
              {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.amt || 0 )}
            </span>
          ),
          bankCharge:(
            <span>
              {currencySymbolByCode(record?.inId?.inCr || "INR")} {formatAmountIndianRupees(record?.crg || 0 )}
            </span>
          ),
          referanceNo:(<span>{record?.ref || "-"}</span>),
          date: dateTimeFormat(record?.dt),
        };
      });
      setPaymentRecordData(tableData);
    } else {
      setPaymentRecordData([]);
    }
  }, [paymentRecords]);

  const handleRowClick = (e,_id)=>{
    e.stopPropagation();
    const data = paymentRecords.recordsData.filter((item)=> item?._id === _id)
    setSelectedItem(data[0]);
    setOpenPaymentInfoModel(true);
  }

  const closePaymenttInfoModel = () => {
    setOpenPaymentInfoModel(false);
    setSelectedItem({});
  };
  const textColor = useColorModeValue("secondaryGray.900", "white");
  
  const [isOpen, setIsOpen] = useState(false);
  const [activeBtn,setActiveBtn] = useState("")

  const toggleMenu = (btn) => {
    setIsOpen(!isOpen);
    setActiveBtn(btn)
  };
  const handleClose = () => {   
    setActiveBtn("");   
    setIsOpen(false)
  };

  if (loading) {
    return (
      <SpinnerLoader/>
    );
  }
  return (
    <>
       <Box  display="flex" className="mx-3" justifyContent="space-between">
       <Box display="flex">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
          mt={5}
        >
          Payment Received
        </Text>
        </Box>
        <Box display="flex" mt={2} className="add-new-btn">
        <Box>
          <Menu>
          <MenuButton p="0px">
          <Box  className='menu-ellipsis-btn'><FaEllipsisV /></Box>

          </MenuButton>
          <MenuList
             boxShadow={shadow}
             p="0px"
             mt="10px"
             borderRadius="10px"
             bg={menuBg}
             border="none"
          >
            <Flex w="100%" mb="0px" flexDirection="column">
            <Box
                ps="20px"
                pt="10px"
                pb="8px"
                className="menu-text"
                borderBottom="1px solid gray"
                borderColor={borderColor}
                onClick={()=>toggleMenu('xlsx')}
                display="flex"
              >
                <CiExport size={20} className="mx-1"/> <span>Export XLSX</span>
              </Box>
            </Flex>
            <Flex w="100%" mb="0px" flexDirection="column">
            
            </Flex>
           <Box marginRight={40}>
           {isOpen && (
            <ExportDataModel
              filename={"Payment Received_"}
              type="invoicePayment"
              role={role}
              isOpen={isOpen}
              handleClose={handleClose}
              activeBtn={activeBtn}
            />
          )}
           </Box>
          </MenuList>
        </Menu>
          </Box>
        </Box>
      </Box>
      <Box pt={{ base: "40px", md: "10px", xl: "10px" }}>
        <RecordTable
          columnsData={paymentRecordColumns}
          tableData={paymentRecordData}
          type={"Payment Received"}
          role={role}
          expenseType = 'Payment Received '
          openInfoModal = {handleRowClick}
        />
      </Box>
      {openPaymentInfoModel && (
        <InvoicePaymentRecordModel
          openInfoModal={openPaymentInfoModel}
          closeInfoModal={closePaymenttInfoModel}
          selectedItem={selectedItem}   
          role={role}
     
        />
      )}
    </>
  );
};

export default InvoicePaymentRecords;
